import Vue from "vue"
import VueRouter from "vue-router"
import fn from "@/mixins/helpers"

Vue.use(VueRouter)

let isMobile = fn.methods.$isMobile()
let MainLayout = null

/* LAYOUTS */
if (isMobile) {
  MainLayout = () => import("@/themes/layouts/mobile/MainLayout")
} else {
  MainLayout = () => import("@/themes/layouts/web/MainLayout")
}

import AuthLayout from "../themes/layouts/shared/AuthLayout"
import PrivacyStatementLayout from "../themes/layouts/shared/PrivacyStatementLayout"

/* MODULES */
import LoginRoutes from "@/modules/auth/routes"
import DashboardRoutes from "@/modules/dashboard/routes"
import SettingRoutes from "@/modules/settings/routes"
import UserRoutes from "@/modules/users/routes"
import PersonRoutes from "@/modules/persons/routes"
import RoleRoutes from "@/modules/roles/routes"
import PermissionRoutes from "@/modules/permissions/routes"
import LogRoutes from "@/modules/logs/routes"
import QueueRoutes from "@/modules/queues/routes"
import CompanyRoutes from "@/modules/companies/routes"
import CertificateRoutes from "@/modules/certificates/routes"
import ChangeLogRoutes from "../modules/changelog/routes"

const routes = [
  {
    path: "/auth/:locale",
    component: AuthLayout,
    children: [...LoginRoutes]
  },
  {
    path: "/privacystatement",
    component: PrivacyStatementLayout
  },
  {
    path: "/app",
    component: MainLayout,
    children: [
      ...DashboardRoutes,
      ...UserRoutes,
      ...PersonRoutes,
      ...RoleRoutes,
      ...PermissionRoutes,
      ...SettingRoutes,
      ...LogRoutes,
      ...QueueRoutes,
      ...CompanyRoutes,
      ...CertificateRoutes,
      ...ChangeLogRoutes,
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.BASE_URL
})

export default router
